export const contractTypeOptions = [
  {
    label: "Escritório privativo",
    value: "po",
  },
  ...(import.meta.env.VITE_WOBA_INVENTORY_RELEASED === "false"
    ? [
        {
          label: "BTS",
          value: "bts",
        },
      ]
    : [
        {
          label: "Serviço extra",
          value: "extra-service",
        },
      ]),
  {
    label: "Endereço fiscal",
    value: "tax_address",
  },
  {
    label: "Posição fixa",
    value: "fixed_position",
  },
];

export type PoType = "pronto" | "personalizado" | "sob_medida";

export const poTypeOptions: { label: string; value: PoType; id: string }[] = [
  { label: "Pronto", value: "pronto", id: "po-type-pronto" },
  {
    label: "Personalizado",
    value: "personalizado",
    id: "po-type-personalizado",
  },
  { label: "Sob medida", value: "sob_medida", id: "po-type-sob-medida" },
];

export const getPoTypeLabel = (value: PoType | undefined): string | undefined =>
  poTypeOptions.find((o) => o.value === value)?.label;

// PED-13775/13778: política sob a qual o contrato é firmado. Só
// "friccao_zero" liga o recálculo automático de pró-rata nativo
// (PED-13777..13780) na criação e na edição de vigência — "anterior"
// mantém o comportamento legado (sem recálculo retroativo).
export type CommercialPolicy = "anterior" | "friccao_zero";

export const commercialPolicyOptions: {
  label: string;
  value: CommercialPolicy;
  id: string;
}[] = [
  {
    label: "Fricção zero (pró-rata nativo)",
    value: "friccao_zero",
    id: "commercial-policy-friccao-zero",
  },
  {
    label: "Anterior (sem pró-rata nativo)",
    value: "anterior",
    id: "commercial-policy-anterior",
  },
];

export const getCommercialPolicyLabel = (
  value: CommercialPolicy | undefined,
): string | undefined =>
  commercialPolicyOptions.find((o) => o.value === value)?.label;

export const renewalIndicatorOptions = [
  {
    label: "IGP-M",
    value: "IGP-M",
  },
  {
    label: "IPCA",
    value: "IPCA",
  },
];
